import { RichText, Text, DateField, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import breakpointsConstants from '../../constants/breakpoints.constants';
import ctaTypes from '../../enums/CTA.enums';
import useEEActive from '../../hooks/useEEActive';
import useMediaQuery from '../../hooks/useMediaQuery';
import { targetLinkdsk } from '../../utils/targetDskLink';
import CTA from '../@shared/CTA';
import DictionaryTerm from '../@shared/dictionaryTerm';
import RoutableNotEditableLink from '../@shared/routableNotEditableLink';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import NewsDetailMedia from './components/media';
import { NewsDetailModel } from './models/newsDetail.model';
import { TNewsDetailProps } from './types/newsDetail.types';
import useFormatDate from '../../hooks/useFormatDate';
import SocialMediaBar from '../@shared/socialMediaBar';
import './styles.scss';

const NewsDetail: FC<TNewsDetailProps> = (props) => {
  const model = new NewsDetailModel(props);
  const isEE = useEEActive();
  const isDesktop = useMediaQuery(`(min-width: ${breakpointsConstants['tbl-p']}px)`);
  const formattedDate = useFormatDate(model.newsDate?.value);

  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className="news-detail">
      <div className="news-detail__header">
        {model.eyebrow && <Text field={model.eyebrow} tag="div" className="news-detail__eyebrow" />}
        {model.title && <Text field={model.title} tag={model.headingTag} className="news-detail__title" />}
        {model.newsDate && <DateField field={model.newsDate} tag="div" className="news-detail__date" render={() => formattedDate} />}
        {model.socialMediaBarProps && <SocialMediaBar {...model.socialMediaBarProps} extraClassName="news-detail__social-media-bar" />}
      </div>

      {model.hasMedia ? (
        <NewsDetailMedia desktopImage={model.image} mobileImage={model.mobileImage} showVideo={model.showVideo} videoUrl={model.videoUrl} />
      ) : (
        <div className="news-detail__seperate-line" />
      )}

      {model.categories?.length > 0 && (
        <div className="news-detail__categories-wrapper">
          <span className="news-detail__categories-title">
            <DictionaryTerm keyword="cnhi-news-categories" />
          </span>
          <div className="news-detail__categories-tags-wrapper">
            {model?.categories?.map((category) => (
              <RoutableNotEditableLink key={category?.id} href={category?.href} className="news-detail__categories-tag--link">
                <span className="news-detail__categories-tag--name">{category?.name}</span>
              </RoutableNotEditableLink>
            ))}
          </div>
        </div>
      )}
      {model.detailedDescription && <RichText field={model.detailedDescription} className="news-detail__description rich-text" />}
      {(isEE || model.showCtaWrapper) && (
        <div className="news-detail__cta-wrapper">
          {(isEE || model.showPrimaryCta) && (
            <CTA
              type={ctaTypes.primaryOrange}
              field={model.primaryCta}
              target={targetLinkdsk(model?.primaryCta, isDesktop)}
              extraClassName="news-detail__cta-primary"
            />
          )}
          {(isEE || model.showSecondaryCta) && (
            <CTA
              type={ctaTypes.secondaryBlack}
              field={model.secondaryCta}
              target={targetLinkdsk(model?.secondaryCta, isDesktop)}
              extraClassName="news-detail__cta-secondary"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default withSitecoreContext()(NewsDetail);
